// @flow
import {
  RECEIVE_INDEX,
  SET_API,
  SET_GUIDE,
  SET_VERSION
} from '../reducers/version';

import createAction from './utils/createAction';

export const receiveIndex = createAction(RECEIVE_INDEX);
export const setAPI = createAction(SET_API);
export const setGuide = createAction(SET_GUIDE);
export const setVersion = createAction(SET_VERSION);



// WEBPACK FOOTER //
// ./src/actions/version.js